const getElQuantity = event => parseInt(
    $(event.target)
        .parent()
        .find('.quantity-detail')
        .val(),
    10,
);

const getElFakeQuantity = event => parseInt(
    $(event.target)
        .parents('.fake-quantity-form')
        .find('.fake-quantity-input')
        .text(),
    10,
);

const getElLimitQuantity = (event, limit) => parseInt(
    $(event.target)
        .parent()
        .data(limit),
    10,
);

const modifyQuantity = (event, amount, quantity) => {
    if ($(event.target).parents('.fake-quantity-form').length) {
        const quantityEl = $(event.target)
            .parent()
            .find('.fake-quantity-input');

        const quantityInput = $('.quantity-select .quantity');

        quantityEl.text(quantity + amount);
        quantityInput.val(quantity + amount);
    } else {
        const quantityEl = $(event.target)
            .parent()
            .find('.quantity-detail');

        const quantitySelect = $(event.target)
            .parent()
            .find('.quantity');

        quantityEl.val(quantity + amount);
        quantitySelect.val(quantity + amount);
    }
};

const updateQuantity = (event, kindOfUpdate) => {
    let quantity = getElQuantity(event);
    const maxquantity = getElLimitQuantity(event, kindOfUpdate);

    if ($(event.target).parents('.fake-quantity-form').length) {
        quantity = getElFakeQuantity(event);
    }

    if (quantity !== maxquantity) {
        if (kindOfUpdate === 'maxquantity') {
            modifyQuantity(event, 1, quantity);
        } else {
            modifyQuantity(event, -1, quantity);
        }
    }
};

const quantityChangeEvent = () => {
    $('body').on('click', '.more-btn-detail, .less-btn-detail', (event) => {
        const kindOfUpdate = $(event.currentTarget).hasClass('more-btn-detail')
            ? 'maxquantity' : 'minquantity';

        updateQuantity(event, kindOfUpdate);
    });
};

const mouseEvents = () => {
    const nextProd = $('.next-product');
    nextProd.mouseenter(() => {
        $('body').css('overflow-x', 'hidden');
    });
    nextProd.mouseleave(() => {
        $('body').css('overflow-x', 'auto');
    });
};

const shareProductEvent = () => {
    $('body').on('click', '.share-product', () => {
        const container = $('.social-container');
        const share = $('.share-product');

        if (share.hasClass('social-active')) {
            container.slideUp();
            share.removeClass('social-active');
        } else {
            container.slideDown();
            share.addClass('social-active');
        }
    });
};

const ctabarQuantity = () => {
    const docBody = $(document.body);
    docBody.on('click', '.ctabar-quantity-wrapper .quantity-form span, .ctabar-quantity-wrapper .quantity-form button', (e) => {
        const thisTarget = $(e.currentTarget);
        const targetButton = thisTarget.hasClass('less-btn-detail')
            ? $('.prices-add-to-cart-actions .less-btn-detail') : $('.prices-add-to-cart-actions .more-btn-detail');
        targetButton.trigger('click');
    });
};

module.exports = {
    quantityChangeEvent,
    mouseEvents,
    shareProductEvent,
    ctabarQuantity,
};
